import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const fetchSiteMeta = async () => (await client.get("/site/meta")).data;

export const fetchJournal = async (params = {}) => (await client.get("/journal", { params })).data;
export const fetchArticle = async (slug) => (await client.get(`/journal/${slug}`)).data;
export const fetchRituals = async (params = {}) => (await client.get("/rituals", { params })).data;
export const fetchCoreRituals = async () => (await client.get("/core-rituals")).data;
export const fetchRitual = async (slug) => (await client.get(`/rituals/${slug}`)).data;
export const fetchProducts = async (params = {}) => (await client.get("/products", { params })).data;
export const fetchCollection = async (slug) => (await client.get(`/collections/${slug}`)).data;
export const fetchProduct = async (slug) => (await client.get(`/products/${slug}`)).data;
export const fetchLibrary = async () => (await client.get("/library")).data;
export const subscribeNewsletter = async (email) => (await client.post("/newsletter", { email })).data;
export const joinWaitlist = async ({ email, name, product_slug }) =>
  (await client.post("/waitlist", { email, name, product_slug })).data;

// Checkout
export const createCheckout = async ({ items, origin_url, email }) =>
  (await client.post("/checkout/session", { items, origin_url, email })).data;
export const fetchCheckoutStatus = async (sessionId) =>
  (await client.get(`/checkout/status/${sessionId}`)).data;

// Quiz
export const fetchQuizQuestions = async () => (await client.get("/quiz/questions")).data;
export const submitQuiz = async (answers) => (await client.post("/quiz/recommend", { answers })).data;
